import { format, set } from 'date-fns';
import { API, ShareAPI } from '../../API';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { OpinionCard } from '../OpinionCard/OpinionCard';
import { LoaderSmall } from '../LoaderSmall/LoaderSmall';
import { ampli } from '../../ampli';
import Tooltip from '../Tooltip/Tooltip';
import { ReactComponent as MergeIcon } from '../../pages/NarrativePage/assets/merge.svg';
import { showRequestError } from '../../utils/requestError';
import { WidgetContentModal } from '../WidgetContentModal/WidgetContentModal';
import Modal from '../Modal';
import { Paginator } from '../Paginator/Paginator';
import { AddToNarrativeModal } from '../AddToNarrativeModal/AddToNarrativeModal';
import { AddToSourceGroupModal } from '../AddToSourceGroupModal/AddToSourceGroupModal';
import { CountriesOpinionCard } from '../OpinionCard/CountriesOpinionCard';

import styles from './OpinionsWidget.module.scss';

const opinionsData = {
  objects: [
    {
      id: 52478836,
      title:
        "Trump threatens 50% tariffs on Chinese goods if China doesn't rescind its retaliatory tariffs by April 9th.",
      rating: 14.0,
      top_sources: [
        { id: 227202, name: 'rbc.ru', platform: 'WEB', image_url: null },
        {
          id: 99076734,
          name: 'rt.com/business',
          platform: 'WEB',
          image_url: null,
        },
        { id: 227070, name: 'kp.ru', platform: 'WEB', image_url: null },
      ],
      attitude_balance: {
        negotiate_share: 0,
        attack_share: 0,
        cooperate_share: 0,
        counteract_share: 100,
        attitude: 'counteract',
      },
      country_code: 'RU',
      messages_count: 114,
    },
    {
      id: 52492558,
      title:
        'China opposes US "reciprocal tariffs," calling them protectionist and harmful, and will take countermeasures to protect its interests.',
      rating: 8.553463112822994,
      top_sources: [
        { id: 129342515, name: 'CGTN', platform: 'FACEBOOK', image_url: null },
        {
          id: 129332323,
          name: 'China Daily',
          platform: 'FACEBOOK',
          image_url: null,
        },
        {
          id: 129342516,
          name: 'China Xinhua News',
          platform: 'FACEBOOK',
          image_url: null,
        },
      ],
      attitude_balance: {
        negotiate_share: 0,
        attack_share: 100,
        cooperate_share: 0,
        counteract_share: 0,
        attitude: 'attack',
      },
      country_code: 'CN',
      messages_count: 154,
    },
    {
      id: 52514147,
      title:
        "Lula invited Denmark's PM to Brazil to discuss EU-Mercosur deal, COP-30, Ukraine war, and multilateralism, offering support on Greenland.",
      rating: 6.0,
      top_sources: [
        { id: 55156390, name: 'uol.com.br', platform: 'WEB', image_url: null },
        {
          id: 55156399,
          name: 'terra.com.br',
          platform: 'WEB',
          image_url: null,
        },
        {
          id: 247366628,
          name: 'itatiaia.com.br',
          platform: 'WEB',
          image_url: null,
        },
      ],
      attitude_balance: {
        negotiate_share: 0,
        attack_share: 0,
        cooperate_share: 100,
        counteract_share: 0,
        attitude: 'cooperate',
      },
      country_code: 'BR',
      messages_count: 19,
    },
    {
      id: 52492563,
      title:
        "Trump's protectionist policies, including tariffs, aim to reshape globalization in favor of the U.S., risking trade wars and economic disruption.",
      rating: 1.0,
      top_sources: [
        { id: 236802, name: 'inform.kz', platform: 'WEB', image_url: null },
        {
          id: 113231813,
          name: 'baigenews.kz',
          platform: 'WEB',
          image_url: null,
        },
        { id: 79616609, name: 'egemen.kz', platform: 'WEB', image_url: null },
      ],
      attitude_balance: {
        negotiate_share: 0,
        attack_share: 0,
        cooperate_share: 0,
        counteract_share: 100,
        attitude: 'counteract',
      },
      country_code: 'KZ',
      messages_count: 20,
    },
    {
      id: 52488307,
      title:
        "Trump's import tariffs trigger global market shock and retaliation threats, prompting countermeasures from governments and companies.",
      rating: 0.0,
      top_sources: [
        {
          id: 49934,
          name: 'Press TV \ud83d\udd3b',
          platform: 'TWITTER',
          image_url: null,
        },
        {
          id: 85350370,
          name: 'PressTV',
          platform: 'TELEGRAM',
          image_url: null,
        },
        {
          id: 129332340,
          name: 'Press TV Highlights',
          platform: 'FACEBOOK',
          image_url: null,
        },
      ],
      attitude_balance: {
        negotiate_share: 0,
        attack_share: 0,
        cooperate_share: 0,
        counteract_share: 100,
        attitude: 'counteract',
      },
      country_code: 'IR',
      messages_count: 15,
    },
  ],
  page: 1,
  size: 5,
  total: 10,
};


export const OpinionsWidget = ({
  report,
  story,
  isShare,
  sourceGroups,
  countries,
  countryGroups = [],
  startDate,
  endDate,
  viewMode='rating',
  showCountries=false,
}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const [opinions, setOpinions] = useState(null);
  const [modal, setModal] = useState({ isVisible: false, opinion: null });
  const [selectedOpinions, setSelectedOpinions] = useState([]);
  const [mergeOpinionsModal, setMergeOpinionsModal] = useState({
    isActive: false,
    opinion_ids: [],
    new_title: '',
    isLoading: false,
    error: null,
  });
  const [addToCaseModal, setAddToCaseModal] = useState({ isOpen: false, opinionId: null, });
  const [addToGroupModal, setAddToGroupModal] = useState({ isOpen: false, opinionId: null, });

  const api = isShare ? ShareAPI : API;

  const fetchOpinions = (page=1) => {
    let size = 5;
    if (!story) return;
    if (opinions !== null) {
      setOpinions(null);
    }
    const urlParams = new URLSearchParams();

    urlParams.set('size', size);
    urlParams.set('page', page);
    
    if(viewMode === 'messages') {
      urlParams.set('sort', '-messages_count');
    } 
    
    if (sourceGroups.length > 0) {
      sourceGroups.forEach((sourceGroup) => {
        urlParams.append('source_group_ids', sourceGroup.value);
      });
    }
    if (countries.length > 0) {
      countries.forEach((country) => {
        urlParams.append('source_country_ids', country.value);
      });
    }
    if (countryGroups.length > 0) {
      countryGroups.forEach((groupId) => {
        urlParams.append('country_group_ids', groupId);
      });
    }
    if (startDate) {
      urlParams.append('date_from', format(startDate, 'yyyy-LL-dd'));
    }
    if (endDate) {
      urlParams.append('date_to', format(endDate, 'yyyy-LL-dd'));
    }
    api
      .fetch(
        'GET',
        `/API/v1/topic-modeling/${report?.id}/events/${
          story?.id
        }/opinions?${urlParams.toString()}`,
      )
      .then((data) => {
        setOpinions(data);
      })
      .catch((e) => { showRequestError(e, t('Top opinions')); setOpinions([]); });
  };

  useEffect(() => {
    fetchOpinions();
  }, [story]);

  useEffect(() => {
    if (showCountries) {
      setOpinions(opinionsData);
    }
  }
  , []);

  return (
    <div className="report-section">
      <div className={styles.widgetHeader} id='opinionsWidget'>
        <h3>{t('Top opinions')}</h3>
        <div className={styles.widgetControls}>
          {currentUser?.is_super_admin && selectedOpinions?.length > 0 ? (
            <Tooltip content={t('Merge')} position="bottom">
              <button
                className={styles.mergeButton}
                onClick={() =>
                  setMergeOpinionsModal({
                    isActive: true,
                    opinion_ids: selectedOpinions,
                    new_title:
                      opinions?.objects
                        ?.filter((opinion) =>
                          selectedOpinions.includes(opinion.id),
                        )
                        .sort((a, b) => b.rating - a.rating)?.[0]?.title || '',
                    isLoading: false,
                    error: null,
                  })
                }
              >
                <MergeIcon />
              </button>
            </Tooltip>
          ) : (
            ''
          )}
          {story?.opinions_sampling_rate ? (
            <div
              className="sampling"
              data-tooltip-id="sampling-tooltip"
              data-tooltip-content={t('We used sampling to analyze this data. A sample is a statistically significant representation of the dataset, suitable for AI analysis. The sampling rate indicates the part of the total dataset included in the analysis.')}
              data-tooltip-place="bottom-start"
            >
              {t('Sampling')}:
              <span className='sampling__value'> {story?.opinions_sampling_rate.toPrecision(4)}%</span>
              <Tooltip id="sampling-tooltip" style={{ width: '200px' }} />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>

      {opinions ? (
        opinions?.objects?.length > 0 ? (
          opinions?.objects?.map((opinion, index) => (
            showCountries ? <CountriesOpinionCard
              key={`${opinion.id}-${index}`}
              report={report}
              opinion={opinion}
              isAttitude={true}
            /> :
            <OpinionCard
              key={`${opinion.id}-${index}`}
              opinion={opinion}
              viewMode={viewMode}
              onClick={(opinion) => {
                setModal({ isVisible: true, opinion: opinion });
                ampli.track({
                  event_type: 'Open wiget popup in event',
                  event_properties: {
                    user_id: currentUser?.id,
                    workspace_id: currentUser?.workspace_id,
                    report_id: report?.id,
                    popup_type: 'Opinion card',
                    popup_value: 'Opinion: ' + opinion.id,
                  },
                });
              }}
              isAdmin={currentUser?.is_super_admin}
              report={report}
              story={story}
              selectedOpinions={selectedOpinions}
              onDelete={() => fetchOpinions()}
              onEdit={() => fetchOpinions()}
              onCheckboxClick={(opinion) => {
                if (selectedOpinions.includes(opinion.id)) {
                  setSelectedOpinions(
                    selectedOpinions.filter((item) => item !== opinion.id),
                  );
                } else {
                  setSelectedOpinions([...selectedOpinions, opinion.id]);
                }
              }}
            />
          ))
        ) : (
          <div className={styles.noData}>
            {t('Opinions have not been detected')}
          </div>
        )
      ) : (
        <div className={styles.widgetLoader}>
          <LoaderSmall />
        </div>
      )}
      <Paginator
        size={opinions?.size}
        page={opinions?.page}
        total={opinions?.total}
        onPageChange={(page) => {
          fetchOpinions(page)
        }}
        id={'opinionsWidget'}
      />

      {modal.isVisible ? (
        <WidgetContentModal
          tabIndex={1}
          infoModal={modal.isVisible}
          isChart={true}
          platformOption={null}
          type={null}
          subType={null}
          stateAffiliatedId={null}
          countryId={countries?.length > 0 ? countries : null}
          // platformsOptions={platformOptions}
          audienceRange={null}
          narrative={report}
          sourceGroup={
            sourceGroups.length > 0
              ? sourceGroups?.map((sourceGroup) => sourceGroup.value)
              : null
          }
          source={null}
          sentimentOptions={null}
          eventIdsOptions={[story.id]}
          opinionIdsOptions={modal.opinion ? [modal.opinion.id] : null}
          startDate={startDate}
          endDate={endDate}
          isShare={isShare}
          onChange={(bool) => {
            setModal({ isVisible: bool, opinion: null });
          }}
          opinion={modal.opinion}
          event={story}
          showAddToActions={true}
          onAddToCase={(bool) => {
            setAddToCaseModal({
              isOpen: bool,
              opinionId: modal.opinion.id,
            });
          }}
          onAddToGroup={(bool) => {
            setAddToGroupModal({
              isOpen: bool,
              opinionId: modal.opinion.id,
            });
          }}
        />
      ) : (
        ''
      )}

      {mergeOpinionsModal.isActive ? (
        <Modal
          isVisible={mergeOpinionsModal.isActive}
          className={styles.mergeEventsModal}
          title={t('Merge stories')}
          content={
            mergeOpinionsModal?.opinion_ids?.length < 2 ? (
              <p className={styles.errorStoriesMerge}>
                {t('Please select at least 2 opinions to merge')}
              </p>
            ) : (
              <div className={styles.mergeStoriesModal}>
                {mergeOpinionsModal.error ? (
                  <p className={styles.errorStoriesMerge}>
                    {mergeOpinionsModal.error}
                  </p>
                ) : (
                  ''
                )}
                <div className="form-element">
                  <label htmlFor="new-story-title">{t('Title')}&#42;</label>
                  <input
                    type="text"
                    id="new-story-title"
                    value={mergeOpinionsModal.new_title}
                    required
                    onChange={(e) =>
                      setMergeOpinionsModal({
                        ...mergeOpinionsModal,
                        new_title: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            )
          }
          footer={
            <>
              {mergeOpinionsModal.opinion_ids?.length < 2 ? (
                ''
              ) : (
                <button
                  className="btn-primary"
                  disabled={mergeOpinionsModal.isLoading}
                  onClick={() => {
                    setMergeOpinionsModal({
                      ...mergeOpinionsModal,
                      isLoading: true,
                    });

                    API.fetch(
                      'POST',
                      `/API/v1/topic-modeling/${report.id}/events/${story.id}/opinions/merge`,
                      null,
                      {
                        opinion_ids: mergeOpinionsModal.opinion_ids,
                        new_title: mergeOpinionsModal.new_title,
                        new_description: '',
                      },
                    )
                      .then(() => {
                        setMergeOpinionsModal({
                          isActive: false,
                          opinion_ids: [],
                          new_title: '',
                          isLoading: false,
                          error: null,
                        });

                        setSelectedOpinions([]);

                        fetchOpinions();
                      })
                      .catch((e) => {
                        setMergeOpinionsModal({
                          ...mergeOpinionsModal,
                          isLoading: false,
                          error: t(
                            'Something went wrong. Please, try again...',
                          ),
                        });
                        showRequestError(e, t('Merge opinions'));
                      });
                  }}
                >
                  {mergeOpinionsModal.isLoading ? <LoaderSmall /> : t('Merge')}
                </button>
              )}
              <button
                className="btn-reset"
                disabled={mergeOpinionsModal.isLoading}
                onClick={() =>
                  setMergeOpinionsModal({
                    isActive: false,
                    opinion_ids: [],
                    new_title: '',
                    isLoading: false,
                    error: null,
                  })
                }
              >
                {t('Cancel')}
              </button>
            </>
          }
          onClose={() =>
            setMergeOpinionsModal({
              isActive: false,
              opinion_ids: [],
              new_title: '',
              isLoading: false,
              error: null,
            })
          }
        />
      ) : (
        ''
      )}

      {addToCaseModal.isOpen ? (
        <AddToNarrativeModal
          isOpen={addToCaseModal.isOpen}
          deduplication={false}
          caseId={report?.id}
          eventIds={[story?.id]}
          opinionIds={[addToCaseModal.opinionId]}
          areAllMessagesSelected={true}
          startDate={startDate}
          endDate={endDate}
          sourceGroups={sourceGroups}
          countries={countries}
          onChange={(bool) => {
            setAddToCaseModal({
              isOpen: bool,
              contentTypes: null,
              sentiment: null,
            });
          }}
        />
      ) : (
        ''
      )}
      {addToGroupModal.isOpen ? (
        <AddToSourceGroupModal
          isOpen={addToGroupModal.isOpen}
          deduplication={false}
          areAllMessagesSelected={true}
          startDate={startDate}
          endDate={endDate}
          sourceGroups={sourceGroups}
          countries={countries}
          narrative={report}
          eventIds={[story?.id]}
          opinionIds={[addToGroupModal.opinionId]}
          onChange={(bool) => {
            setAddToGroupModal({
              isOpen: bool,
              contentTypes: null,
              sentiment: null,
            });
          }}
        />
      ) : (
        ''
      )}
    </div>
  );
};
